import { render } from "./InterviewBlock.vue?vue&type=template&id=01b8c514"
import script from "./InterviewBlock.vue?vue&type=script&lang=js"
export * from "./InterviewBlock.vue?vue&type=script&lang=js"

import "./InterviewBlock.vue?vue&type=style&index=0&id=01b8c514&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__